export default "__VITE_ASSET__3c6645f7__"